import Boundary, { BOUNDARY_TYPE, IBoundary } from '../abstract/Boundary';

export interface IVirtualBoundary extends IBoundary {}

class VirtualBoundaryModel extends Boundary implements IVirtualBoundary {
  constructor() {
    super(BOUNDARY_TYPE.VIRTUAL);
  }

  toJSON() {
    return {
      ...super.toJSON(),
    };
  }
}

export default VirtualBoundaryModel;
